<template>
  <div class="columns group-header">
    <div class="column is-6">
      <div class="is-size-6 has-text-weight-semibold m-l-20">
        <span class="has-text-primary m-r-2">
          {{ total }}
        </span>
        <span v-if="isFromSearch">{{ $t('results found') }}</span>
        <span v-else>{{ $t('recently viewed') }}</span>
      </div>
    </div>
    <div class="column is-6">
      <div class="is-flex is-size-6 has-text-weight-semibold m-r-20 is-pulled-right">
        <i
          class="icon cls cls-arrow-down has-text-primary is-size-7 is-relative xy-t--2 xy-l-2"
        ></i>
        <span>{{ $t('Sorted by') }}</span>
        <span class="has-text-primary m-l-3">{{ $t('relevance') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightSearchHeader',
  mixins: [],
  components: {},
  props: {
    total: Number,
    isFromSearch: { type: Boolean, default: true }
  }
};
</script>

<style scoped>
.group-header {
  position: relative;
  margin: 0;
  z-index: var(--ce-z-index-0);
  border-bottom: var(--ce-1px) solid var(--ce-border);
  padding-top: var(--ce-4px);

  .column {
    padding: var(--ce-6px) var(--ce-11px);
  }
}
</style>
